import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Heart } from "lucide-react";
import { SITE } from "@/lib/site";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#FAF9F6] border-t border-[#EAE5D9]">
      <div className="mx-auto max-w-7xl px-6 lg:px-12 py-16 lg:py-20 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_aura-bliss-reiki/artifacts/uorreaw9_IMG_6294.jpg"
              alt="Aura Bliss Reiki"
              className="h-14 w-14 rounded-full object-cover ring-1 ring-[#EAE5D9]"
            />
            <div>
              <div className="font-serif text-2xl text-[#2C302E]">{SITE.brand}</div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-[#8A8D86]">by {SITE.founder}</div>
            </div>
          </div>
          <p className="mt-5 text-[#5C605A] max-w-sm leading-relaxed">
            A soft sanctuary for souls in transition — Reiki, regression,
            crystals, and gentle spiritual guidance.
          </p>

          <div className="mt-7 flex gap-3">
            <SocialLink href={SITE.socials.instagram} icon={Instagram} label="Instagram" testid="social-instagram" />
            <SocialLink href={SITE.socials.facebook} icon={Facebook} label="Facebook" testid="social-facebook" />
            <SocialLink href={SITE.socials.youtube} icon={Youtube} label="YouTube" testid="social-youtube" />
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.22em] text-[#8A8D86] mb-5">Explore</div>
          <ul className="space-y-3 text-[#2C302E]">
            <li><a href="/#services">Services</a></li>
            <li><a href="/#about">About Archana</a></li>
            <li><Link to="/blog">Journal</Link></li>
            <li><a href="/#faq">FAQs</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.22em] text-[#8A8D86] mb-5">Stay in touch</div>
          <div className="text-[#2C302E] space-y-2">
            <div>{SITE.email}</div>
            <div>{SITE.phone}</div>
            <div className="text-sm text-[#5C605A]">{SITE.location}</div>
          </div>
        </div>
      </div>

      <div className="border-t border-[#EAE5D9]">
        <div className="mx-auto max-w-7xl px-6 lg:px-12 py-6 flex flex-wrap items-center justify-between gap-4 text-xs text-[#8A8D86]">
          <div>© {new Date().getFullYear()} {SITE.brand}. All rights reserved.</div>
          <div className="flex items-center gap-1.5">Made with <Heart className="h-3 w-3 text-[#B35B47] fill-[#B35B47]" /> for souls returning home.</div>
        </div>
      </div>
    </footer>
  );
};

const SocialLink = ({ href, icon: Icon, label, testid }) => {
  const isComingSoon = href === "coming-soon";
  if (isComingSoon) {
    return (
      <span
        aria-label={`${label} — coming soon`}
        data-testid={testid}
        title="Coming soon"
        className="relative h-10 w-10 rounded-full border border-[#EAE5D9] flex items-center justify-center text-[#8A8D86] cursor-not-allowed group"
      >
        <Icon className="h-4 w-4" />
        <span className="absolute -top-8 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-[#2C302E] text-[#FAF9F6] text-[10px] uppercase tracking-[0.2em] px-2.5 py-1 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Coming soon
        </span>
      </span>
    );
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      data-testid={testid}
      className="h-10 w-10 rounded-full border border-[#EAE5D9] flex items-center justify-center text-[#2C302E] hover:bg-[#2C302E] hover:text-[#FAF9F6] transition-colors"
    >
      <Icon className="h-4 w-4" />
    </a>
  );
};

export default Footer;
